// Silent warm-up ping. The backend's serverless DB/Functions can cold-start when
// idle, making a user's first real call slow. Hitting the anonymous, cheap
// GET /api/health (SELECT 1) on load — and gently while the tab stays open —
// warms both so the first meaningful request is fast. It is purely a warm-up:
// fire-and-forget, never awaited, never blocks render, result and errors ignored.
// (The 24/7 keep-alive is a separate App Insights availability test on the same
// endpoint; this only helps the current user's session.)

const WARM_MS = 4 * 60 * 1000;

export function startKeepAlive(): void {
  const ping = () => {
    void fetch('/api/health').catch(() => {});
  };
  ping();
  // Only ping while the tab is actually visible — no point warming for a
  // backgrounded tab, and it avoids needless calls on phones left locked.
  window.setInterval(() => {
    if (document.visibilityState === 'visible') ping();
  }, WARM_MS);
}
